import { styled, TextField } from "@mui/material";

const StyledOutlinedTextField = styled(TextField)(({ theme }) => ({
    "& label.Mui-focused": {
        "& .Mui-disabled": {
            color: theme.palette.text.disabled
        }
    },
    "& .MuiInputLabel-root.Mui-disabled": {
        color: theme.palette.text.disabled,
        fontWeight: "normal"
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            borderWidth: 1.5,
            borderColor: theme.palette.divider,
        },
        "&:hover fieldset": {
            borderWidth: 1.5,
            borderColor: theme.palette.mode === "dark" ? theme.palette.action.selected : theme.palette.text.disabled,
        },
        "&.Mui-focused fieldset": {
            borderWidth: 1.5,
            borderColor: theme.palette.primary.main,
        },
    },
    "& .MuiOutlinedInput-root.Mui-disabled": {
        backgroundColor: theme.palette.background.default,
        "&.Mui-disabled fieldset": {
            borderWidth: 1.5,
            borderColor: theme.palette.mode === "dark" ? theme.palette.action.disabledBackground : theme.palette.action.disabled,
        }
    },
    "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: theme.palette.text.disabled
    },
    "& .MuiOutlinedInput-input": {
        color: theme.palette.text.primary,
        fontWeight: "normal",
    },
    "& .MuiSvgIcon-root": {
        color: theme.palette.text.primary
    },
    "& .MuiSvgIcon-root.Mui-disabled": {
        color: theme.palette.background.default
    }
}));

export default StyledOutlinedTextField;